export default function WebFeatureLoading() {
    return (
        <div className="w-full text-center py-4">
            <span
                className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-[#A6D143] border-r-transparent align-middle"
                role="status"
                aria-label="Loading"
            />
        </div>
    );
}
